import loadcss from '~/utils/loadcss';
import ENV from '~/config/env';

const loadfonts = () => {
  loadcss('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
  loadcss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/mt-ui-components/latest/styles.css`);
};

export const loadIcons = () => {
  loadcss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/mt-ui-components/latest/styles.css`);
};

export default loadfonts;
